module.exports = __webpack_public_path__ + "img/usuario.6f6bbb16.png";